import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Tooltip } from '@sine/sine-ui-components';

const StyledSpan = styled.span`
  opacity: ${(props) => (props.inProgress ? '0.4' : '1')};
`;

function RateLimitClickWrapper({ delay, children, toolTipText, toolTipDirection, toolTipWidth, onClick }) {
  const timerRef = useRef();
  const [inProgress, setInProgress] = useState(false);
  const [timeLeft, setTimeLeft] = useState(delay);

  useEffect(() => {
    if (inProgress && timeLeft > 0) {
      timerRef.current && clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setTimeLeft((prevTimeLeft) => prevTimeLeft - 1);
      }, 1000);
      return () => clearTimeout(timerRef.current);
    } else {
      setInProgress(false);
      setTimeLeft(delay);
    }
  }, [inProgress, timeLeft]);

  const _onClick = (event) => {
    if (!inProgress) {
      onClick(event);
      setInProgress(true);
    }
  };

  return (
    <Tooltip
      content={inProgress ? `Retry in ${timeLeft} seconds` : toolTipText}
      placement={toolTipDirection}
      maxWidth={toolTipWidth}
    >
      <StyledSpan inProgress={inProgress} onClick={_onClick} data-st-id='ratelimited'>
        {children}
      </StyledSpan>
    </Tooltip>
  );
}

RateLimitClickWrapper.propTypes = {
  delay: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  toolTipText: PropTypes.string.isRequired,
  toolTipDirection: PropTypes.string,
  toolTipWidth: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default RateLimitClickWrapper;
